import React, { useEffect, useState } from "react";
import { useGoogleLogin } from "@react-oauth/google";
import { googleLogin } from "../../../../utility/apiServices/userServices";
import { setLocalStorage } from "../../../../utility/local/functions/setlocalStorage";
import { Link, useNavigate } from "react-router-dom";
import { Icon } from "@iconify/react";
import api from "../../../../utility/local/axios/api";

const GoogleLoginButton = ({data}) => {
  const navigate = useNavigate();
  const [user, setUser] = useState(null);
  const [profile, setProfile] = useState(null);

  const login = useGoogleLogin({
    onSuccess: async (credentialResponse) => {
      try {
        setUser(credentialResponse);
      
     
      } catch (error) {
        console.error("Google Login Error:", error);
      }
    },
    onError: (error) => {
      console.error("Google Login Failed:", error);
    },
  });


  const getUserInfo = async (user) => {
    if (!user?.access_token) return null; 

    try {
      const response = await api.get(
        `https://www.googleapis.com/oauth2/v1/userinfo?access_token=${user.access_token}`,
        {
          headers: {
            Authorization: `Bearer ${user.access_token}`,
            Accept: "application/json",
          },
        }
      );
      return response?.data;
    } catch (error) {
      console.error("Error Fetching User Info:", error?.response?.data);
      return null;
    }
  };

  useEffect(() => {
    if (user) {
      (async () => {
        const profileData = await getUserInfo(user);
        setProfile(profileData);
      })();
    }
  }, [user]);


  useEffect(() => {
    if (profile) {
      (async () => {
        const requestData = {
          ...profile,
          ...data
        };
        console.log(data  , 'REQUEST DATA IS WORKIGN --')
        const response = await googleLogin(requestData);
        console.log("LOGIN OR SIGNUP WORIING ", response);
        const {accessToken, refreshToken, user} =response
        setLocalStorage(accessToken, refreshToken, user);
        navigate("/");
      })();
    }
  }, [profile]);


  return (
    <Link onClick={login}>
      <Icon icon="devicon:google" fontSize={24} />
    </Link>
  );
};

export default GoogleLoginButton;
